export enum ICON_TYPE {
  DOUBLE_RIGHT = 'double-right',
  DOUBLE_LEFT = 'double-left',
  DOUBLE_ARROW_RIGHT = 'double-arrow-right',
  DOUBLE_ARROW_LEFT = 'double-arrow-left',
}

/**
 * Options for icon configuration
 */
export interface IIconOptions {
  RTL?: boolean;
  showCaption?: boolean;
  caption?: string;

  collapse?: boolean;

  /**
   * A Function to return the icon type based on the collapse state and options.
   * This will override the default icon type logic if provided.
   * And this will be used as the image name.
   *
   * @param collapse - The current collapse state (true if collapsed, false if expanded).
   * @param options - An object containing the icon configuration options.
   * @returns The icon type to be used for the icon.
   */
  imageTypeGetter?: (
    collapse: boolean,
    options: { config: IIconOptions },
  ) => ICON_TYPE;
}
